export default {
    "auth.login.title": "Connexion",
    "auth.login.seo_description": "Connectez-vous à votre compte CitoyenPro pour reprendre votre préparation à l'examen de citoyenneté canadienne.",
    "auth.login.welcome": "Bon retour !",
    "auth.login.subtitle": "Connectez-vous pour continuer votre apprentissage",
    "auth.login.email": "Adresse email",
    "auth.login.email_placeholder": "votre@email.com",
    "auth.login.password": "Mot de passe",
    "auth.login.password_placeholder": "••••••••",
    "auth.login.remember_me": "Se souvenir de moi",
    "auth.login.forgot_password": "Mot de passe oublié ?",
    "auth.login.submit": "Se connecter",
    "auth.login.logging_in": "Connexion...",
    "auth.login.no_account": "Pas encore de compte ?",
    "auth.login.create_account": "Créer un compte",
    "auth.login.back_home": "Retour à l'accueil",
    "auth.login.reset_success": "Votre mot de passe a été modifié avec succès. Veuillez vous connecter avec vos nouveaux identifiants.",

    "auth.signup.title": "Créer un compte",
    "auth.signup.seo_description": "Inscrivez-vous sur CitoyenPro et commencez à préparer votre examen de citoyenneté avec les meilleurs outils.",
    "auth.signup.welcome": "Commencez dès aujourd'hui",
    "auth.signup.subtitle": "Créez votre compte CitoyenPro en quelques secondes",
    "auth.signup.full_name": "Nom complet",
    "auth.signup.full_name_placeholder": "Jean Dupont",
    "auth.signup.submit": "Créer mon compte",
    "auth.signup.signing_up": "Création du compte...",
    "auth.signup.have_account": "Déjà un compte ?",
    "auth.signup.login": "Se connecter",
    "auth.signup.success": "Compte créé avec succès ! Veuillez vérifier votre boîte mail pour confirmer votre inscription.",
    "auth.signup.terms_prefix": "J'accepte les",
    "auth.signup.terms_link": "conditions d'utilisation",
    "auth.signup.terms_and": "et la",
    "auth.signup.privacy_link": "politique de confidentialité",

    "auth.forgot.title": "Mot de passe oublié",
    "auth.forgot.subtitle": "Entrez votre email pour recevoir un lien de réinitialisation",
    "auth.forgot.submit": "Envoyer le lien",
    "auth.forgot.sending": "Envoi en cours...",
    "auth.forgot.back_login": "Retour à la connexion",
    "auth.forgot.success": "Si un compte existe pour cet email, vous recevrez un lien de réinitialisation sous peu.",

    "auth.reset.title": "Réinitialiser le mot de passe",
    "auth.reset.welcome": "Nouveau mot de passe",
    "auth.reset.subtitle": "Choisissez un nouveau mot de passe sécurisé",
    "auth.reset.new_password": "Nouveau mot de passe",
    "auth.reset.confirm_password": "Confirmer le mot de passe",
    "auth.reset.submit": "Mettre à jour",
    "auth.reset.updating": "Mise à jour...",
    "auth.reset.error_match": "Les mots de passe ne correspondent pas.",
    "auth.reset.error_length": "Le mot de passe doit contenir au moins 6 caractères."
};
